import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M42.043 224.586C50.4178 250 69.7664 264.728 101.533 264.728C133.299 264.728 152.648 250 161.023 224.586C163.911 215.634 165.066 204.66 165.066 163.364C165.066 122.067 163.911 111.094 161.023 102.141C152.648 76.7281 133.299 62 101.533 62C69.7664 62 50.4178 76.7281 42.043 102.141C39.1551 111.094 38 122.067 38 163.364C38 204.66 39.1551 215.634 42.043 224.586ZM81.8954 217.367C80.1627 212.169 79.2964 206.393 79.2964 163.364C79.2964 120.335 80.1627 114.559 81.8954 109.361C84.7833 100.697 91.1366 96.3655 101.533 96.3655C111.929 96.3655 118.282 100.697 121.17 109.361C122.903 114.559 123.769 120.335 123.769 163.364C123.769 206.393 122.903 212.169 121.17 217.367C118.282 226.03 111.929 230.362 101.533 230.362C91.1366 230.362 84.7833 226.03 81.8954 217.367Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }